module.exports = __webpack_public_path__ + "static/media/injuredAboveHeart.44c56255.mp3";